export default "__VITE_ASSET__BiYNQZSM__"